var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13003 6.16367C2.31579 5.95934 2.63201 5.94428 2.83634 6.13003L8 10.8243L13.1637 6.13003C13.368 5.94428 13.6842 5.95934 13.87 6.16367C14.0557 6.368 14.0407 6.68422 13.8363 6.86997L8.33634 11.87C8.14563 12.0433 7.85438 12.0433 7.66367 11.87L2.16367 6.86997C1.95934 6.68422 1.94428 6.368 2.13003 6.16367Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.e617c571845dba77bd82f1738fd8803d.svg";
export { ForwardRef as ReactComponent };